import React from "react"
import game from "mancala.png"

const Mancala = props => <img src={game} className="game" {...props} />

export default Mancala
